import { makeStyles } from '@material-ui/core';
import LogoDark from '../../assets/univerus_logo_dark.svg';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 40,
    transition: 'height 200ms ease',
  },
});

/**
 * LogoIcon - Univerus Hub icon logo component
 * Used in collapsed sidebar, always displays the dark logo variant for consistency
 */
const LogoIcon = () => {
  const classes = useStyles();

  return <img src={LogoDark} alt="Univerus Central" className={classes.img} />;
};

export default LogoIcon;
